import React, {useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";

import {LookLayoutIcon} from "../../../common/icons";
import COLOR_THEMES, {COLORS} from "../../../../colorThemes";
import {setLookPageOpened, setLookIntroStep} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import LookIntroPopper from "../lookIntro/lookIntroPopper";
import {LOOK_INTRO_STEPS} from "../../core/constants";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";

const LookSideBarLayoutButton = (props) => {

  const {intl, lookPageOpened, activeTheme, popupCloseClick, setLookPageOpened, history, disabled, introStep,
    setLookIntroStep, sidebarButtonClicked, showRoomLayoutsButton} = props;
  const anchorRef = useRef(null);

  if (!showRoomLayoutsButton) {
    return null
  }

  const lookViewOpened = lookPageOpened === ROUTES.view;

  const layoutButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarRooms);
    if (introStep === LOOK_INTRO_STEPS.layoutsAndRooms) {
      setLookIntroStep();
      return false;
    }
    if (lookPageOpened && popupCloseClick) {
      popupCloseClick();
    } else {
      setLookPageOpened(ROUTES.view);
      history.push(ROUTES.view);
    }
    sidebarButtonClicked();
  }

  const realDisabled = disabled || ((introStep !== LOOK_INTRO_STEPS.welcome) && (introStep !== LOOK_INTRO_STEPS.layoutsAndRooms));

  return (
    <li className="look-sidebar__list-item">
      <Tooltip title={intl.formatMessage({id:"tooltip.сameraViews"})} placement="right">
        <IconButton aria-label={intl.formatMessage({id:"tooltip.сameraViews"})}
                    ref={anchorRef}
                    disabled={realDisabled}
                    className={"look-icon look-sidebar__button" + (lookViewOpened ? " look-icon--active" : "")
                      + (introStep === LOOK_INTRO_STEPS.layoutsAndRooms ? " look-sidebar__button--intro" : "")}
                    onClick={layoutButtonClick}>
          <SvgIcon>
            <LookLayoutIcon color={
              realDisabled ? "rgba(0, 0, 0, 0.26)" : lookViewOpened ? COLORS.white : COLOR_THEMES[activeTheme].primary
            }/>
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <LookIntroPopper anchorRef={anchorRef} currentStep={LOOK_INTRO_STEPS.layoutsAndRooms}/>
    </li>
  )
};

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  const {lookPageOpened, introStep} = store.lookState;
  const {activePreset} = store.bathroomVisualizerState;

  return {
    activeTheme,
    lookPageOpened,
    introStep,
    activePreset,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookIntroStep,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookSideBarLayoutButton)
  )
)
